import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';
import { getRowsProcessed } from 'Utils';
import { workItemLabel } from 'Utils/nomenclature';
import DiscoveryTooltip from 'DiscoveryTooltip';

function formatDuration(ms) {
  if (!ms || ms < 0) return '00:00:00';
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

const SearchProgress = (props) => {
  const status = props.inProgress || {};
  const totalRows = status.total_rows || 0;
  const totalProcessed =
    status.total_processed != null ? status.total_processed : getRowsProcessed(status);
  const state = status.state || status.glue_status || 'running';
  const stateUpper = String(state).toUpperCase();
  const isComplete = stateUpper === 'COMPLETED' || stateUpper === 'SUCCEEDED';
  let percent = totalRows > 0 ? Math.floor((totalProcessed / totalRows) * 100) : 0;
  if (isComplete) {
    percent = 100;
  } else {
    // Until the run actually reports complete, never show 100% — the floor can
    // round a nearly-finished run up to 100 while work remains. Cap at 99%.
    percent = Math.min(99, percent);
  }
  percent = Math.min(100, Math.max(0, percent));
  let variant = 'primary';

  if (state === 'FAILED' || state === 'STOPPED') variant = 'warning';

  const displayPercent = Math.min(isComplete ? 100 : 99, Math.max(isComplete ? 100 : 15, percent));
  const notice = status.notice;

  const creationTime = status.creationTime ?? null;
  const elapsed = creationTime ? Date.now() - creationTime : null;
  const durationStr = elapsed != null ? formatDuration(elapsed) : null;

  const workItemKind = status.workItemKind ?? null;
  const workItemsCompleted = status.workItemsCompleted ?? null;
  const workItemsTotal = status.workItemsTotal ?? null;

  const parts = [`${displayPercent}% Complete`];
  if (workItemsTotal > 0 && workItemsCompleted != null) {
    parts.push(`${Number(workItemsCompleted).toLocaleString()} of ${Number(workItemsTotal).toLocaleString()} ${workItemLabel(workItemKind)} processed`);
  } else if (totalRows > 0 && totalProcessed != null) {
    parts.push(`${Number(totalProcessed).toLocaleString()} of ${Number(totalRows).toLocaleString()} records processed`);
  }
  if (durationStr) parts.push(`Running for ${durationStr}`);
  const statusText = parts.join('.  ') + '.';

  return (
    <div className='report-progress-bar position-relative text-center'>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translateX(-50%) translateY(-50%)'
        }}
      >
        {statusText}
        {notice && (
          <DiscoveryTooltip text={notice} placement='top'>
            <span className='ml-2'><ImInfo style={{ fontSize: '1.1em' }} color='#315DFF' /></span>
          </DiscoveryTooltip>
        )}
      </div>
      <ProgressBar now={percent} variant={variant} />
    </div>
  );
}

export default SearchProgress;